export enum AppRouteEnum {
  EMPLOYEE = 'employee',
  SEARCH = 'search',
  COMPANY = 'company',
  INVITATION = 'invitation',
}
